'use strict';

var React = require('react');

var SvgAnalyticsCohortMinor = function SvgAnalyticsCohortMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2v2a2 2 0 0 1-2 2h-2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-10Zm8 6h-2v-2h2v2Zm-4-2h-2v2h2v-2Zm-2-2h2v-2h-2v2Zm6 0h-2v-2h2v2Zm2-2v2h2v-2h-2Zm-6 8h-2v2h2v-2Z"
  }));
};

exports.SvgAnalyticsCohortMinor = SvgAnalyticsCohortMinor;
